const Resources = {

    table_headers: [
        { 
          text:  'Name',  
          align: 'start', 
          value: 'name',
          type:  'link',
        },
        { 
            text: 'Group',           
            value: 'group' 
        },
        { 
            text:   'Description',       
            value:  'description' 
        },
        {   
            text:  'Start salary',  
            value: 'start_salary' ,
            type:  'number',
        },
        {   
            text:  'End salary',          
            value: 'end_salary',
            type:  'number',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates',
            href:   '/associates',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Positions',
            href:   '/associate-positions',
            arrow:  " ",
        },
    ],

    excel_file_headers: {
        'Group': 'group_id',
        'Name': 'name',
        'Start Salary': 'start_salary', 
        'End Salary': 'end_salary',
        'Description': 'description'
    },

    excel_fields_required: {
        group_id: true,
        name: true,
        start_salary: false,
        end_salary: false,
        description: true,
    },

    helps: [
        {
            label: '¿How to add a new Position?', 
            instruction: `https://scribehow.com/embed/How_To_Add_A_New_Position__J9ovk8k6RjSO6_1MnaYEwQ?as=scrollable`
        },
    ],

    empty_format_data: [
        {
            group_id:       '',
            name:           '',
            start_salary:   '',
            end_salary:     '',
            description:    '',
        },
    ],
}

export default Resources;